import Api from "~/service/Api";
import AppUserType from "~/constants/AppUser/AppUserType";

function fetchOneCustomer(customerId, query) {
  return Api.get(`/ui-meet-3d/greeting-bot/customers/${customerId}`, query);
}

function updateCustomer(customerId, data) {
  return Api.put(`/ui-meet-3d/greeting-bot/customers/${customerId}`, data);
}

function fetchOneProvider(providerId, query) {
  return Api.get(`/ui-meet-3d/greeting-bot/providers/${providerId}`, query);
}

function updateProvider(providerId, data) {
  return Api.put(`/ui-meet-3d/greeting-bot/providers/${providerId}`, data);
}

class GreetingBotRepository {
  fetchOne(userId, userType, query) {
    switch (userType) {
      case AppUserType.CUSTOMER:
        return fetchOneCustomer(userId, query);
      case AppUserType.PROVIDER:
        return fetchOneProvider(userId, query);
      default:
        throw new Error(`Unknown user type: {$userType}`);
    }
  }

  update(userId, userType, data) {
    switch (userType) {
      case AppUserType.CUSTOMER:
        return updateCustomer(userId, data);
      case AppUserType.PROVIDER:
        return updateProvider(userId, data);
      default:
        throw new Error(`Unknown user type: {$userType}`);
    }
  }
}

export default GreetingBotRepository;
